import { z } from 'zod';
import { legalClientAddressSchema } from './ILegalClientAddress';
import { contactInformationSchema } from './ILegalClientContactInformation';

export const legalClientSchema = z.object({
  idLegalClient: z.number(),
  idCountry: z.number(),
  idBusinessForm: z.number(),
  FirstName: z.string().nullable(),
  LastName: z.string().nonempty(),
  SurName: z.string().nullable().optional(),
  Email: z.string().nullable().optional(),
  Birthdate: z.string().nullable().optional(),
  Birthplace: z.string().nullable().optional(),
  PlaceOfDeath: z.string().nullable().optional(),
  DateOfDeath: z.string().nullable().optional(),
  idGender: z.number().nullable().optional(),
  Gender: z.string().nullable().optional(),
  TaxNumber: z.string().nullable().optional(),
  SalesTaxNumber: z.string().nullable().optional(),
  idAcademicTitle: z.number().nullable().optional(),
  AcademicTitle: z.string().nullable().optional(),
  BusinessForm: z.string().nullable().optional(),
  idLegalClientType: z.number(),
  LegalClientType: z.string(),
  idLegalClientUser: z
    .number()
    .nullable()
    .transform(x => x ?? -1),
  loginPossible: z.boolean(),
  passwordResetRequired: z.boolean(),
  last_login_at: z.string().nullable().optional(),
  isReceivingEmailEnabled: z.boolean(),
  Updated_at: z.string().nullable().optional(),
  Created_at: z.string().nullable().optional(),
  syncWithArnoTop: z.boolean(),
  //LegalClientUser: legalClientUserSchema,
  idArnoTop: z.number().nullable().optional(),
  //syncWithArnotop: z.boolean().optional(),
  idContactGroup: z.number().nullable().optional(),
  ContactGroup: z.string().nullable().optional(),
  LastSyncWithArnoTop: z.string().nullable().optional(),
  idArnoTopIntern: z.number().nullable().optional(),
  idLegalRole: z.number().nullable().optional(),
  enableInvoiceReminding: z.boolean().optional(),
  enableCertificateReminding: z.boolean().optional(),

  // !!! Attr. ohne Attr. in der DB
  syncType: z.number().optional(),
  resetPassword: z.boolean().optional(),
});

export const legalClientFullObjectSchema = legalClientSchema.extend({
  AddressArray: z.array(legalClientAddressSchema),
  ContactInformationArray: z.array(contactInformationSchema),
});

export type ILegalClient = z.infer<typeof legalClientSchema>;
export type ILegalClientFullObject = z.infer<
  typeof legalClientFullObjectSchema
>;
